import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import type { UserSettingsRouteFragment } from './user-settings.types';
import { REDIRECT_MAPPING } from './user-settings.types';

// Inverse the mapping from webapp -> legacy to legacy -> webapp
const TAB_FRAGMENTS: Record<string, UserSettingsRouteFragment> =
  Object.fromEntries(
    Object.entries(REDIRECT_MAPPING).map(([webapp, legacy]) => [
      legacy,
      webapp as UserSettingsRouteFragment,
    ]),
  );

// This ensures that all users who will be accessing the legacy user settings route will
// not bypass the A/B test logic, which will skew the metrics we're trying to look at.
export const LegacyUserSettingsGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const location = inject(Location);
  const redirectToPhp = inject(RedirectToPhp);

  // Automatically use the legacy page when accessed with `?w=f`
  if (route.queryParams.w === 'f') {
    return redirectToPhp.doRedirect(state.url);
  }

  // Need to determine what route to use if using a fragment from legacy
  let webappUrl = '/user/settings';
  if (route.fragment && route.fragment in TAB_FRAGMENTS) {
    webappUrl = `/user/settings/${TAB_FRAGMENTS[route.fragment]}`;
  }

  return location.createUrlTree([webappUrl]);
};
